module.exports = __webpack_public_path__ + "img/pe.b1cff325.svg";